<template>
  <div
    v-if="visibleMetrics.length > 0"
    class="post-metrics-row px-2 px-sm-4 pb-2 d-flex align-center flex-wrap"
  >
    <v-tooltip
      v-for="metric in visibleMetrics"
      :key="metric.key"
      location="bottom"
    >
      <template v-slot:activator="{ props }">
        <span
          class="metric-item mr-3 d-inline-flex align-center"
          v-bind="props"
        >
          <v-icon
            size="16"
            class="mr-1"
          >
            {{ metric.icon }}
          </v-icon>
          <span class="text-caption">{{ metric.value.toLocaleString() }}</span>
        </span>
      </template>
      <span>{{ $t(`content-creator.table.labels.metrics.${metric.key}`) }}</span>
    </v-tooltip>
    <span
      v-if="latestFetchedAt"
      class="text-caption text-medium-emphasis"
    >
      {{ $t('content-creator.table.labels.metrics.as-of') }}:
      {{ formatFetchedAt(latestFetchedAt) }}
    </span>
  </div>
</template>

<script>
const METRIC_DEFINITIONS = [
  { key: 'views', field: 'impressions', icon: 'mdi-eye-outline' },
  { key: 'likes', field: 'likes', icon: 'mdi-thumb-up-outline' },
  { key: 'comments', field: 'comments', icon: 'mdi-comment-outline' },
  { key: 'shares', field: 'shares', icon: 'mdi-share-variant-outline' },
]

export default {
  name: 'PostMetricsRow',
  props: {
    posts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    postsWithMetrics() {
      return (this.posts || []).filter((post) => post?.metrics?.fetchedAt)
    },
    // Sums each metric across the platform posts of this content.
    // A metric is hidden when no platform provides it (all null).
    visibleMetrics() {
      return METRIC_DEFINITIONS.map((definition) => {
        const values = this.postsWithMetrics
          .map((post) => post.metrics[definition.field])
          .filter((value) => value != null)
        if (values.length === 0) return null
        return {
          ...definition,
          value: values.reduce((sum, value) => sum + value, 0),
        }
      }).filter(Boolean)
    },
    latestFetchedAt() {
      const dates = this.postsWithMetrics.map((post) => new Date(post.metrics.fetchedAt))
      if (dates.length === 0) return null
      return new Date(Math.max(...dates))
    },
  },
  methods: {
    formatFetchedAt(date) {
      return date.toLocaleDateString(this.$i18n.locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      })
    },
  },
}
</script>
